import { render, staticRenderFns } from "./charte.vue?vue&type=template&id=c3dbe504"
import script from "./charte.vue?vue&type=script&lang=js"
export * from "./charte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports